<template>
	<div class="page">
		<div class="pub_nav">
			<div class="status_bar"></div>
			<div class="nav_box">
				<div class="search_box">
					<input type="text" class="input" v-model="searchKey" placeholder-class="placeColor"
						placeholder="请输入商家名称" />
					<img src="../assets/img/pro_i02_blue.png" class="icon" @click="search()"></img>
				</div>
			</div>
		</div>
		<div class="category_wrap">
			<div class="menus">
				<div class="menu" :class="menuCur == 0 ? 'cur' : ''" @click="handleNav(0)" key="">离我最近</div>
				<template v-for="(item,index) in cate1">
					<div class="menu" :class="menuCur == item.id?'cur':''" @click="handleNav(item.id)" :key="index">
						{{item.name}}
					</div>
				</template>
			</div>
			<div class="wrap_r">
				<div class="wrap_r_t">
					<div class="lables">
						<template v-for="(item,index) in cate2">
							<div class="lable" :class="lableCur==item.id?'cur':''" @click="clickLable(item.id)">
								{{item.name}}</div>
						</template>
					</div>
					<!-- <img src="../assets/img/idx_img5.jpg" class="icon"></img> -->
				</div>
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
					<div class="list">
						<div class="item" v-for="(item,index) in shopList">
							<div class="left" @click="handleGoDetails(item.id,item.dis_show)"><img :src="item.logo" class="img" mode="aspectFill"></img></div>
							<div class="mid" @click="handleGoDetails(item.id,item.dis_show)">
								<div>{{item.name}}</div>
								<div>距离您{{item.dis_show}}</div>
								<div>电话：{{item.tel}}</div>
							</div>
							<div class="right">
								<div class="lm" @click="handleGoLocation(item.lat,item.lng,item.name,item.address)">去这里</div>
								<div v-if="item.is_sdl === 1" class="lm" style="background-image: linear-gradient(to top right, #FFCC00, #FFCC66);">联盟商家</div>
							</div>
						</div>
					</div>
				</van-list>
			</div>
		</div>
		<footer>
			<TheFooterBar :active="3" />
		</footer>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	import BaseHeader from "../components/BaseHeader";
	import {
		getCommunitysService
	} from '../service/shopService';
	import {
		Toast
	} from 'vant';
	import wx from 'weixin-js-sdk'
	import {
		getWxSharService
	} from '../service/weChatService'
	import {
		getAddressService
	} from '../service/untilService';
	import Loading from '../components/Loading';
	import TheFooterBar from "../components/base/TheFooterBar";
	import {
		getCategoryService,
		getCategoryService2
	} from '@/service/salesmanService';
	import Cookies from 'js-cookie';
	import {
		isWeixinOrAlipayTools
	} from '../util/tools';
	// import {wecharShare} from "../util/weChat.js";


	export default {
		name: "NearbyShop",
		data() {
			return {
				myLocation: {
					address: "",
					// address:"北京市",
					// latitude:33.05614,
					latitude: 0,
					// longitude:112.94793,
					longitude: 0,
				},
				shopList: [],
				loading: false,
				finished: false,
				offset: {
					page: 1,
					limit: 10,
				},
				active: 0,
				items: [{
					id: 0,
					text: '离我最近'
				}],
				show: false,
				showLoading: false, //是否加载
				searchKey: '',
				typeId: 0,
				index: 0,
				isSearchGetData: 0,
				menus: ['日用百货', '家电五金', '汽车用品', '母婴玩具', '数码办公', '美妆/个护', '服装/服饰', '鞋包/鞋帽', '旅游/保健', '日用百货', '家电五金', '汽车用品',
					'母婴玩具', '数码办公', '美妆/个护', '服装/服饰', '鞋包/鞋帽'
				],
				menuCur: 0,
				lableCur: 0,
				cate1: [],
				cate2: []
			}
		},
		mounted() {
			// this.getData();
			// this.showLoading = false;
			// this.show = true;
			this.active = parseInt(Cookies.get('c_active')) || 0;
			this.searchKey = Cookies.get('c_search') || '';
			this.typeId = parseInt(Cookies.get('c_typeId')) || 0;
			this.getCategory();
			this.share()
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
		},
		methods: {
			share() {
				const that = this;
				getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
					if (result.status === 1) {
						console.log('share', result);
						that.$wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: result.datas.appId, // 公众号名称，由商户传入
							timestamp: result.datas.timestamp, // 时间戳，自1970年以来的秒数
							nonceStr: result.datas.nonceStr, // 随机串
							signature: result.datas.signature, // 微信签名
							jsApiList: ['updateTimelineShareData',
								'updateAppMessageShareData'
							] // 必填，需要使用的JS接口列表
						});
						that.$wx.ready(function() {
							//分享到朋友圈
							that.$wx.updateTimelineShareData({
								title: '附近商家', // 分享标题
								desc: '附近商家',
								link: location.href,
								imgUrl: 'https://www.shoudaole.cn/uploads/default/logo.png', // 分享图标
								success: function() {
									// Toast('分享成功');
								}
							});
							//分享给朋友
							that.$wx.updateAppMessageShareData({
								title: '附近商家', // 分享标题
								desc: '附近商家',
								link: location.href,
								imgUrl: 'https://www.shoudaole.cn/uploads/default/logo.png', // 分享图标
								success: function() {
									// Toast('分享成功');
								}
							});
						});
					} else {
						Toast(result.msg);
					}
				});
			},
			handleNav(id) {
				// this.typeId = this.cate1[index].id;
				// Cookies.set('c_typeId', this.typeId);
				this.menuCur = id;
				// 获取二级分类
				this.getCategory2(this.menuCur);
				// this.search('handleNav');
			},

			clickLable(id) {
				this.lableCur = id;
				this.typeId = id;
				this.getMyLocation();
				// this.search('handleNav');
			},

			hadleGetLocation() {
				// this.$router.go(0);
				window.location.reload()
			},
			getCategory2(pid) {
				getCategoryService2(pid).then(res => {
					if (res.status === 1) {
						this.cate2 = res.datas;
						console.log('cate2', res.datas);
						if (this.menuCur == 0) {
							this.lableCur = 0;
						} else {
							this.lableCur = res.datas[0].id;
						}
						if(res.datas.length == 0){
							this.typeId = 0;
						} else {
							this.typeId = res.datas[0].id;
						}
						this.getMyLocation();
					} else {
						console.log(res.msg);
					}
				})
			},
			getCategory() {
				getCategoryService().then(res => {
					if (res.status === 1) {
						// res.datas.forEach(ele => {
						// 	const temp = {
						// 		id: ele.id,
						// 		text: ele.name
						// 	}
						// 	this.items.push(temp)
						// })
						this.cate1 = res.datas;
						this.index = 1;
						// this.menuCur = res.datas[0].id;
						this.getCategory2(res.datas[0].id);
						// this.getData();
						// this.getLocation();
						// this.getMyLocation();
					} else {
						console.log(res.msg);
					}
				})
			},
			getMyLocation() {
				var geolocation = new qq.maps.Geolocation();
				var options = {
					timeout: 9000
				};
				geolocation.getLocation(this.showPosition, this.showErr, options); //或者用getLocation精确度比较高
				this.search('handleNav');
			},
			showPosition(position) {
				console.log(position);
				this.index = 1;
				this.myLocation.latitude = position.lat;
				this.myLocation.longitude = position.lng;
				var str = position.addr;
				str = str.slice(0, 15) + '...';
				this.myLocation.address = str;
				this.getData();
				this.show = true;
				this.showLoading = false;
				// this.setMap();
			},
			showErr() {
				console.log("定位失败");
				this.getMyLocation(); //定位失败再请求定位，测试使用
			},
			//获取当前位置
			getLocation() {
				const that = this;
				// that.getData();return;
				getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
					if (result.status === 1) {
						wx.config({
							// debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							'appId': result.datas.appId, // 公众号名称，由商户传入
							'timestamp': result.datas.timestamp, // 时间戳，自1970年以来的秒数
							'nonceStr': result.datas.nonceStr, // 随机串
							'signature': result.datas.signature, // 微信签名
							'jsApiList': ['getLocation'] // 必填，需要使用的JS接口列表
						});
						wx.ready(function() {
							wx.getLocation({
								type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
								success: function(res) {
									// console.log(res);
									that.myLocation.latitude = res.latitude;
									that.myLocation.longitude = res.longitude;
									getAddressService(res.latitude, res.longitude).then(
										data => {
											if (data.status === 1) {
												that.myLocation.address = data.datas.result
													.formatted_address;
												that.getData();
												that.show = true;
												that.showLoading = false;
											} else {
												Toast(data.msg);
											}
										}).catch(err => {
										that.showLoading = false;
										console.log(err);
									}).finally(() => {
										that.showLoading = false;
									})
								}
							});
						});
					} else {
						Toast(result.msg);
					}
				})
			},

			search(from) {
				console.log('search了');
				console.log(this.searchKey);
				if (this.searchKey == '' && from != 'handleNav') {
					this.getCategory()
					return;
				}
				this.loading = false;
				this.finished = false;
				this.shopList = [];
				this.offset.page = 1;
				this.show = false;
				// Cookies.set('c_search',this.searchKey || '');
				if (from == 'handleNav') {
					this.getData();
				} else if (this.isSearchGetData == 0) {
					this.getData();
					this.isSearchGetData++;
				}
			},
			getUnique(array) {
				let obj = {}
				return array.filter((item, index) => {
					// 防止key重复
					let newItem = item + JSON.stringify(item)
					return obj.hasOwnProperty(newItem) ? false : obj[newItem] = true
				})
			},
			getData() {
				console.log('getData');
				if (this.index == 0) {
					return;
				}
				if (this.myLocation.latitude === 0 || this.myLocation.longitude === 0) {
					// Toast('位置信息获取失败，请刷新重试')
					return;
				}
				console.log(1)
				if (this.menuCur == 0) {
					var type = 0;
					this.cate2 = [{
						id: 0,
						name: '离我最近'
					}]
				} else {
					var type = this.typeId;
				}
				getCommunitysService(this.myLocation.latitude, this.myLocation.longitude, this.offset.page, this.offset
					.limit, this.searchKey, type).then(res => {
					if (res.status === 1) {

						this.shopList = [...this.shopList, ...res.datas];
						this.shopList = this.getUnique(this.shopList);
						console.log(this.shopList)
						// if(this.offset.page === 2){
						//     this.getData();
						// }
						if (res.datas.length !== this.offset.limit) {
							this.finished = true;
							return;
						}
						this.offset.page++;
					} else {
						Toast(res.msg);
					}
				}).catch(err => {
					console.log(err)
				}).finally(() => {
					this.loading = false;
					this.showLoading = false;

				})
			},

			handleGoLocation(lat, lng, name, address) {
				const isWeixinOrAlipay = isWeixinOrAlipayTools();
				if (isWeixinOrAlipay === 'WeiXIN') {
					console.log('inweixin');
					getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
						if (result.status === 1) {
							wx.config({
								// debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
								'appId': result.datas.appId, // 公众号名称，由商户传入
								'timestamp': result.datas.timestamp, // 时间戳，自1970年以来的秒数
								'nonceStr': result.datas.nonceStr, // 随机串
								'signature': result.datas.signature, // 微信签名
								'jsApiList': ['openLocation'] // 必填，需要使用的JS接口列表
							});
							wx.ready(function() {
								wx.openLocation({
									latitude: parseFloat(lat), //目的地latitude
									longitude: parseFloat(lng), //目的地longitude
									name: name,
									address: address,
									scale: 15 //地图缩放大小，可根据情况具体调整
								});
							});
						} else {
							Toast(result.msg);
						}
					})
				} else {
					// 腾讯
					// var backurl = "http://www.shoudaole.cn/dist/#/nearbyShop";
					var url = "https://apis.map.qq.com/tools/routeplan/eword=" + address + "&epointx=" + lat +
						"&epointy=" + lng + "&topbar=1?referer=收到乐&key=HUHBZ-EQY6K-CRRJD-AJITD-QSGJF-GNFE6&back=0";
					/*百度*/
					// var url ="http://api.map.baidu.com/marker?location=34.271454,108.958486&title=百度导航&content="+address+"&output=html&src=yellowpage";
					// $("#mapBg .mapTab .mapBtn_b").attr("href",mapUrl_bd);
					window.location.href = url;
					return;
				}
				// window.location.href = 'http://api.map.baidu.com/geocoder?address=' + address + '&output=html&src=webapp.baidu.openAPIdemo';
			},

			handleGoDetails(shopId, distance) {
				console.log(distance);
				this.$router.push({
					name: 'newshopdetail', //shopDetails
					params: {
						shopId,
						distance,
					}
				})
			},
			handleGoActivity(shopId) {
				this.$router.push({
					name: 'shopActivityDetails',
					params: {
						shopId,
					}
				})
			}
		},
		computed: {
			...mapState({
				userId: state => state.userInfo.userId,
			})
		},
		destroyed() {
			Cookies.remove('c_search');
			Cookies.remove('c_active');
			Cookies.remove('c_typeId');
		},
		components: {
			BaseHeader,
			Loading,
			TheFooterBar
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		background: #faf8f8;
	}

	.pub_nav {
		height: 45px !important;
		padding-top: 0px;
		box-sizing: border-box;
		font-size: 19px;
		color: #fff;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 9999;
		background: linear-gradient(to top right, #A9F0F8, #00BFFF);
		z-index: 200;
	}

	.pub_nav .nav_box {
		justify-content: flex-start;
		display: flex;
		align-items: center;
		position: absolute;
		justify-content: center;
		right: 10px;
		left: 10px;
		height: 45px !important;
	}


	.pub_nav .search_box {
		background: #fff;
		border-radius: 10px;
		height: 33px;
		display: flex;
		align-items: auto;
		padding: 2px;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
	}

	.pub_nav .search_box .input {
		position: relative;
		display: block;
		height: 100%;
		background: none;
		opacity: 1;
		font: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		text-align: inherit;
		text-indent: inherit;
		text-transform: inherit;
		text-shadow: inherit;
		width: 100%;
		color: #000;
		font-size: 12px;
		padding: 10px;
	}

	.pub_nav .search_box .icon {
		width: 45px;
		height: 27px;
	}

	.category_wrap .menus {
		top: 55px !important;
	}

	.category_wrap .wrap_r {
		top: 55px !important;
	}

	.category_wrap .wrap_r_t {
		top: 55px !important;
	}

	.category_wrap {
		display: flex;
		justify-content: space-between;
	}

	.category_wrap .menus {
		width: 87.5px;
		text-align: center;
		position: fixed;
		left: 0;
		bottom: 0;
		background: #fff;
		border-radius: 0 7.5px 7.5px 0;
		overflow-y: scroll;
	}

	.category_wrap .menus .menu {
		line-height: 42.5px;
		font-size: 14px;
		color: #53565c;
	}

	.category_wrap .menus .menu.cur {
		background-image: linear-gradient(to right, #A9F0F8, #fff);
		position: relative;
		color: #00BFFF;
	}

	.category_wrap .menus .menu.cur::before {
		position: absolute;
		content: '';
		width: 4px;
		height: 22px;
		background: #00BFFF;
		border-radius: 0 5px 5px 0;
		left: 0;
		top: 50%;
		margin-top: -11px;
	}

	.category_wrap .wrap_r {
		width: 290px;
		box-sizing: border-box;
		position: fixed;
		right: 0;
		bottom: 0;
		padding: 0 15px 50px 10px;
		overflow-y: scroll;
		background-color: #faf8f8;
	}

	.category_wrap .wrap_r_t {
		position: fixed;
		left: 87.5px;
		right: 15px;
		background: #faf8f8;
		padding: 0 0 10px 10px;
		z-index: 10;
	}

	.category_wrap .wrap_r_t .lables {
		overflow-x: scroll;
		white-space: nowrap;
		padding-right: 35px;
	}

	.category_wrap .wrap_r_t .lables::-webkit-scrollbar {
		display: none;
	}

	.category_wrap .wrap_r_t .lable {
		padding: 0 10px;
		line-height: 25px;
		border-radius: 5px;
		font-size: 12px;
		color: #666666;
		margin-right: 5px;
		background: #fff;
		display: inline-block;
	}

	.category_wrap .wrap_r_t .lable.cur {
		background-image: linear-gradient(to top right, #A9F0F8, #00BFFF);
		color: #fff;
	}

	.category_wrap .wrap_r_t .icon {
		position: absolute;
		right: 0;
		width: 32.5px;
		height: 25px;
		top: 0;
	}

	.category_wrap .list {
		display: flex;
		width: 90%;
		flex-direction: column;
		background-color: #faf8f8;
		padding: 35px 10px 10px 5px;
	}

	.category_wrap .list .item {
		background-color: #fff;
		width: 100%;
		text-align: center;
		display: flex;
		margin-right: 10px;
		flex-direction: row;
		padding: 10px;
		border-radius: 5px;
		margin-top: 10px;
	}

	.category_wrap .list .item:nth-child(3n) {
		margin-right: 0;
	}

	.category_wrap .list .item .left .img {
		height: 60px;
		width: 60px;
		border-radius: 7.5px;
	}

	.category_wrap .list .item .left {
		width: 20%;
	}

	.category_wrap .list .item .mid {
		width: 60%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		text-align: left;
		margin-left: 20px;
	}

	.category_wrap .list .item .right {
		width: 22%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		// margin-top: auto;
		// background-image: linear-gradient(to top right, #A9F0F8, #00BFFF);
		// color: #fff;
		// height: 20px;
		// line-height: 20px;
		// border-radius: 5px;
	}
	
	.category_wrap .list .item .right .lm{
		font-size: 8px;
		width: 100%;
		// width: 20%;
		// margin-top: auto;
		background-image: linear-gradient(to top right, #A9F0F8, #00BFFF);
		color: #fff;
		height: 20px;
		line-height: 20px;
		border-radius: 5px;
	}

	.category_wrap .list .item .tit {
		font-size: 13px;
		color: #333333;
		line-height: 32.5px;
	}
</style>
